/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * Copyright since 2025 Custom modifications
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Academic Free License 3.0 (AFL-3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/AFL-3.0
 */

import getQueryParameters from './urlparser';
import refreshSliders from './slider';

const DRAWER_VERSION = '5.0';

window.isUpdatingUrl = false;

function buildCurrentFilterUrl() {
  const $drawerBody = $('#filters-drawer-body');
  const $filters = $drawerBody.find('#search_filters');

  if (!$filters.length) {
    return window.location.href;
  }

  const $firstChecked = $filters.find('input[type="checkbox"]:checked').first();
  const $firstSlider = $filters.find('.faceted-slider').first();
  
  let baseFilterUrl;
  
  if ($firstChecked.length) {
    baseFilterUrl = $firstChecked.data('search-url');
  } else if ($firstSlider.length) {
    baseFilterUrl = $firstSlider.data('slider-encoded-url');
  }
  
  if (!baseFilterUrl) {
    baseFilterUrl = window.location.href;
  }

  const urlsSplitted = baseFilterUrl.split('?');
  let queryParams = [];

  if (urlsSplitted.length > 1) {
    queryParams = getQueryParameters(urlsSplitted[1]);
  }

  let qParam = queryParams.find(p => p.name === 'q');
  if (!qParam) {
    qParam = {name: 'q', value: ''};
    queryParams.push(qParam);
  }

  const facetFilters = {};

  console.log('Building URL - collecting filters...');

  $filters.find('input[type="checkbox"]:checked').each(function() {
    const $checkbox = $(this);
    const $label = $checkbox.closest('.facet-label');
    const $facet = $label.closest('.facet');
    const facetName = $facet.data('name');
    const $link = $label.find('.search-link');
    const facetValue = $link.clone().children().remove().end().text().trim();

    console.log('Checkbox:', facetName, '=', facetValue);

    if (!facetName) return;

    if (!facetFilters[facetName]) {
      facetFilters[facetName] = [];
    }
    facetFilters[facetName].push(facetValue);
  });

  $filters.find('.faceted-slider').each(function() {
    const $sliderEl = $(this);
    const sliderId = $sliderEl.data('slider-id');
    const $slider = $(`#slider-range_${sliderId}`, $drawerBody);

    if ($slider.hasClass('ui-slider')) {
      const sliderInstance = $slider.data('ui-slider');
      if (sliderInstance) {
        const values = $slider.slider('values');
        const sliderLabel = $sliderEl.data('slider-label');
        facetFilters[sliderLabel] = [values[0] + '-' + values[1]];
      }
    }
  });

  const filterSegments = [];
  for (const facetName in facetFilters) {
    if (facetFilters.hasOwnProperty(facetName)) {
      const values = facetFilters[facetName];
      const segment = facetName + '-' + values.join('-');
      filterSegments.push(segment);
    }
  }

  const newFilterValue = filterSegments.join('/');
  qParam.value = newFilterValue;

  console.log('Filter value:', newFilterValue);

  const queryString = queryParams.map(p => {
    const encodedName = encodeURIComponent(p.name);
    // Encode the value but preserve forward slashes and hyphens
    const encodedValue = p.value.split('/').map(segment => {
      return segment.split('-').map(part => encodeURIComponent(part)).join('-');
    }).join('/');
    return encodedName + '=' + encodedValue;
  }).join('&');
  
  const requestUrl = urlsSplitted[0] + '?' + queryString;

  console.log('Built URL:', requestUrl);

  return requestUrl;
}

function updateCurrentUrl() {
  const newUrl = buildCurrentFilterUrl();
  console.log('=== updateCurrentUrl called ===');
  console.log('Stack trace:', new Error().stack);
  console.log('Updating URL to:', newUrl);
  
  window.isUpdatingUrl = true;
  
  if (window.history && window.history.replaceState) {
    window.history.replaceState({path: newUrl}, '', newUrl);
    console.log('URL updated via replaceState');
    
    // Keep flag true for 2 seconds to block any delayed AJAX responses
    setTimeout(() => {
      window.isUpdatingUrl = false;
      console.log('isUpdatingUrl flag cleared');
    }, 2000);
  } else {
    window.isUpdatingUrl = false;
  }
  
  updateActiveFilters();
}

function updateActiveFilters() {
  const $drawerBody = $('#filters-drawer-body');
  const $filters = $drawerBody.find('#search_filters');
  
  if (!$filters.length) return;
  
  const activeFilters = [];

  $filters.find('input[type="checkbox"]:checked').each(function() {
    const $checkbox = $(this);
    const $label = $checkbox.closest('.facet-label');
    const $facet = $label.closest('.facet');
    const facetName = $facet.data('name');
    const $link = $label.find('.search-link');
    const facetValue = $link.clone().children().remove().end().text().trim();

    activeFilters.push({
      facetName: facetName,
      facetValue: facetValue,
      type: 'checkbox',
      element: $checkbox
    });
  });
  
  $filters.find('.faceted-slider').each(function() {
    const $sliderEl = $(this);
    const sliderId = $sliderEl.data('slider-id');
    const $slider = $(`#slider-range_${sliderId}`, $drawerBody);
    
    if ($slider.hasClass('ui-slider')) {
      const sliderInstance = $slider.data('ui-slider');
      if (sliderInstance) {
        const values = $slider.slider('values');
        const sliderLabel = $sliderEl.data('slider-label');
        const sliderUnit = $sliderEl.data('slider-unit');
        
        activeFilters.push({
          facetName: sliderLabel,
          facetValue: values[0] + ' - ' + values[1] + ' ' + sliderUnit,
          type: 'slider',
          element: $sliderEl
        });
      }
    }
  });
  
  // Remove drawer-active-filters display
  const $drawerActiveFilters = $('#drawer-active-filters');
  if ($drawerActiveFilters.length) {
    $drawerActiveFilters.remove();
  }

  console.log('Active filters updated:', activeFilters);

  // Store for restoration after AJAX updates
  ourActiveFilters = activeFilters;
  
  updateMainPageActiveFilters(activeFilters);
}

function updateMainPageActiveFilters(activeFilters) {
  console.log('Updating main page filters:', activeFilters);
  
  // Find the active filters container - it might be in different locations in mobile vs desktop
  let $container = $('#js-active-search-filters');
  
  console.log('Container found:', $container.length, 'Current classes:', $container.attr('class'));
  console.log('Container visible:', $container.is(':visible'), 'Display:', $container.css('display'));
  
  // If container doesn't exist, try to find it in the page
  if (!$container.length) {
    console.warn('Main page active filters container not found');
    return;
  }
  
  if (!activeFilters || activeFilters.length === 0) {
    $container.addClass('hide').removeClass('active_filters');
    return;
  }
  
  // Show the container and ensure it's visible - use !important via attr
  $container.removeClass('hide').addClass('active_filters');
  $container.attr('style', 'display: block !important; visibility: visible !important; opacity: 1 !important; height: auto !important;');
  
  // Also check and show parent elements, remove responsive hiding classes
  $container.parents().each(function() {
    const $parent = $(this);
    const parentClass = $parent.attr('class') || '';
    
    // Remove Bootstrap responsive hiding classes
    if (parentClass.includes('hidden-')) {
      console.log('Found hidden parent:', parentClass);
      $parent.removeClass('hidden-xs-up hidden-sm-down hidden-md-down hidden-lg-down');
    }
    
    if ($parent.css('display') === 'none') {
      console.log('Showing hidden parent:', $parent.prop('tagName'));
      $parent.show();
    }
  });
  
  const $title = $container.find('.active-filter-title, p');
  console.log('Title element found:', $title.length);
  if ($title.length) {
    $title.removeClass('hidden-xs-up').addClass('active-filter-title');
    $title.attr('style', 'display: inline !important; visibility: visible !important;');
  }
  
  let $list = $container.find('ul');
  
  if (!$list.length) {
    console.log('Creating main page filters list');
    $container.append('<ul></ul>');
    $list = $container.find('ul');
  }
  
  if (!$list.length) {
    console.error('Failed to create main page filters list');
    return;
  }
  
  $list.empty();
  
  activeFilters.forEach(function(filter) {
    const $li = $('<li>', {'class': 'filter-block'});
    const label = $('<span>', {'text': filter.facetName + ': ' + filter.facetValue});
    $li.append(label);
    
    const link = $('<a>', {'class': 'js-search-link', 'href': '#'});
    const closeIcon = $('<i>', {'class': 'material-icons close', 'text': '\ue5cd'});
    link.append(closeIcon);
    $li.append(link);
    
    $list.append($li);
  });
  
  console.log('Main page filters updated. Container HTML:', $container.html());
  console.log('Container now visible:', $container.is(':visible'));
}

function restoreFiltersFromUrl() {
  const $drawerBody = $('#filters-drawer-body');
  const $filters = $drawerBody.find('#search_filters');
  
  if (!$filters.length) return;
  
  const urlParams = new URLSearchParams(window.location.search);
  const qValue = urlParams.get('q');
  
  if (!qValue) {
    console.log('No filters in URL');
    return;
  }
  
  console.log('Restoring filters from URL:', qValue);
  
  const filterSegments = qValue.split('/').filter(f => f);
  
  filterSegments.forEach(function(segment) {
    const parts = segment.split('-');
    if (parts.length >= 2) {
      const facetName = parts[0];
      const facetValue = parts.slice(1).join('-');
      
      console.log('Restoring filter:', facetName, '=', facetValue);
      
      const $facet = $filters.find(`.facet[data-name="${facetName}"]`);
      if ($facet.length) {
        if (parts.length === 4) {
          const sliderId = $facet.find('.faceted-slider').data('slider-id');
          const $slider = $(`#slider-range_${sliderId}`, $drawerBody);
          
          if ($slider.length && $slider.hasClass('ui-slider')) {
            const min = parseInt(parts[2], 10);
            const max = parseInt(parts[3], 10);
            console.log('Setting slider:', min, '-', max);
            $slider.slider('values', [min, max]);
            const $label = $(`#facet_label_${sliderId}`, $drawerBody);
            if ($label.length) {
              $label.text(min + ' - ' + max);
            }
          }
        } else {
          $facet.find('input[type="checkbox"]').each(function() {
            const $checkbox = $(this);
            const $label = $checkbox.closest('.facet-label');
            const $link = $label.find('.search-link');
            const labelValue = $link.clone().children().remove().end().text().trim();
            
            if (labelValue === facetValue) {
              console.log('Checking checkbox:', labelValue);
              $checkbox.prop('checked', true);
            }
          });
        }
      }
    }
  });
  
  console.log('Filters restored');
}

let lastUrl = window.location.href;
setInterval(function() {
  const currentUrl = window.location.href;
  if (currentUrl !== lastUrl) {
    console.log('URL changed:', lastUrl, '->', currentUrl);
    console.log('isUpdatingUrl:', window.isUpdatingUrl);

    if (window.isUpdatingUrl) {
      console.log('URL changed by our code, skipping refresh');
      lastUrl = currentUrl;
      return;
    }

    console.warn('URL changed externally!');
    lastUrl = currentUrl;
  }
}, 100);

prestashop.on('updateFacets', function(event, requestUrl) {
  console.log('updateFacets event, isUpdatingUrl:', window.isUpdatingUrl);
  
  if (window.isUpdatingUrl) {
    console.log('Blocking updateFacets event - preventing AJAX call');
    // Don't call the AJAX - just return false to prevent further processing
    return false;
  }
});

// Store our current filters to restore after AJAX updates
let ourActiveFilters = [];

prestashop.on('updateProductList', function() {
  console.log('updateProductList event, isUpdatingUrl:', window.isUpdatingUrl);
  
  if (window.isUpdatingUrl && ourActiveFilters.length > 0) {
    console.log('Restoring our active filters after product list update');
    setTimeout(() => {
      updateMainPageActiveFilters(ourActiveFilters);
    }, 50);
  }
});

// Intercept history.replaceState to detect external URL changes
const originalReplaceState = window.history.replaceState;
window.history.replaceState = function() {
  console.log('history.replaceState called with:', arguments[2]);
  console.log('Stack:', new Error().stack);
  return originalReplaceState.apply(this, arguments);
};

// Intercept pushState as well
const originalPushState = window.history.pushState;
window.history.pushState = function() {
  console.log('history.pushState called with:', arguments[2]);
  console.log('Stack:', new Error().stack);
  
  // Block pushState if we're updating the URL
  if (window.isUpdatingUrl) {
    console.log('BLOCKED pushState - isUpdatingUrl is true');
    return;
  }
  
  return originalPushState.apply(this, arguments);
};

$(document).ready(() => {
  console.log('Drawer v' + DRAWER_VERSION + ' loaded');

  if ($('body').is('#category, #search')) {
    $('body').removeClass('filters-drawer-open');
    $('#filters-drawer, #filters-drawer-overlay').remove();

    const $leftColumn = $('#left-column');
    if ($leftColumn.length) {
      const $filters = $leftColumn.find('#search_filters_wrapper, #search_filters').first();
      if ($filters.length) {
        if (!$('#filters-storage').length) {
          $('body').append('<div id="filters-storage" style="display:none;"></div>');
        }
        $('#filters-storage').append($filters.clone(true));
      }
    }
  }

  $(document).on('click', '#search_filter_toggler', function(e) {
    e.preventDefault();

    let $wrapper = $('#filters-storage').find('#search_filters_wrapper, #search_filters').first();

    if (!$wrapper.length) {
      $wrapper = $('#left-column').find('#search_filters_wrapper, #search_filters').first();
    }

    if (!$wrapper.length) return false;

    $wrapper.removeClass('hidden-sm-down').css({
      'display': 'block',
      'visibility': 'visible',
      'opacity': '1',
      'position': 'static',
      'left': 'auto'
    });

    let $drawer = $('#filters-drawer');
    let $overlay = $('#filters-drawer-overlay');

    if (!$drawer.length) {
      $('body').append(
        '<div id="filters-drawer-overlay"></div>'
        + '<div id="filters-drawer">'
        + '<div id="filters-drawer-header">'
        + '<button type="button" id="filters-drawer-apply" class="btn btn-primary">Filtrer</button>'
        + '<button type="button" id="filters-drawer-close" aria-label="Close">&times;</button>'
        + '</div>'
        + '<div id="filters-drawer-body"></div>'
        + '</div>'
      );
      $drawer = $('#filters-drawer');
      $overlay = $('#filters-drawer-overlay');

      const closeDrawer = function(){
        $('body').removeClass('filters-drawer-open');
      };

      const applyFilters = function(){
        console.log('Applying filters');
        const requestUrl = buildCurrentFilterUrl();
        
        // Don't do a full page reload - just emit the event to trigger AJAX update
        // The URL is already updated by our code, so we just need to refresh the product list
        prestashop.emit('updateFacets', requestUrl);
        
        // Don't reload the page - this would lose our custom active filters
        // window.location.href = requestUrl;
      };

      $(document).on('click', '#filters-drawer-close', closeDrawer);
      $(document).on('click', '#filters-drawer-overlay', closeDrawer);
      $(document).on('click', '#filters-drawer-apply', function(ev){
        ev.preventDefault();
        applyFilters();
        closeDrawer();
      });
      $(document).on('keyup', function(ev){
        if (ev.key === 'Escape' || ev.keyCode === 27) {
          if ($('body').hasClass('filters-drawer-open')) {
            closeDrawer();
          }
        }
      });
    }

    // Clone filters (don't move original)
    const $clone = $wrapper.clone(false);
    
    // Make clone visible
    $clone.removeClass('hidden-sm-down').css({
      'display': 'block',
      'visibility': 'visible',
      'opacity': '1',
      'position': 'static',
      'left': 'auto'
    });
    
    // Hide price sliders in drawer (they don't work well in modals)
    $clone.find('.faceted-slider').closest('section').hide();
    
    $('#filters-drawer-body').empty().append($clone);
    $('body').addClass('filters-drawer-open');
    
    // Remove event handlers from cloned elements
    $clone.find('a').off('click').removeAttr('href').attr('href', '#');
    $clone.find('input[type="checkbox"]').off('change click').removeAttr('data-search-url');

    setTimeout(() => {
      // Set flag to prevent slider stop events from triggering updates during initialization
      window.isUpdatingUrl = true;
      
      restoreFiltersFromUrl();
      updateActiveFilters();
      
      window.isUpdatingUrl = false;
      console.log('Drawer initialization complete, flag cleared');
    }, 100);

    return false;
  });

  $(document).on('click', '#filters-drawer .facet a, #filters-drawer .facet label', function(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // If click was on the checkbox itself, let the checkbox handler handle it
    if ($(e.target).is('input[type="checkbox"]')) {
      return false;
    }

    const $label = $(this).closest('.facet-label');
    const $checkbox = $label.find('input[type="checkbox"]');
    if ($checkbox.length) {
      const wasChecked = $checkbox.prop('checked');
      $checkbox.prop('checked', !wasChecked);

      const $facet = $label.closest('.facet');
      const facetName = $facet.data('name');
      const $link = $label.find('.search-link');
      const facetValue = $link.clone().children().remove().end().text().trim();

      console.log('Filter clicked:', facetName, '=', facetValue, wasChecked ? 'unchecked' : 'checked');

      updateCurrentUrl();
    }
    
    return false;
  });

  // Handle clicks directly on checkboxes
  $(document).on('click', '#filters-drawer input[type="checkbox"]', function(e) {
    e.stopPropagation();
    e.stopImmediatePropagation();

    const $checkbox = $(this);
    const isChecked = $checkbox.prop('checked');

    const $label = $checkbox.closest('.facet-label');
    const $facet = $label.closest('.facet');
    const facetName = $facet.data('name');
    const $link = $label.find('.search-link');
    const facetValue = $link.clone().children().remove().end().text().trim();

    console.log('Checkbox clicked:', facetName, '=', facetValue, isChecked ? 'checked' : 'unchecked');

    updateCurrentUrl();
  });
  
  // Also intercept checkbox change events to prevent PrestaShop core handlers
  $(document).on('change', '#filters-drawer input[type="checkbox"]', function(e) {
    e.stopImmediatePropagation();
    return false;
  });

  $(document).on('click', '#drawer-active-filters .remove-filter', function(e) {
    e.preventDefault();
    e.stopPropagation();

    const $item = $(this).closest('.active-filter-item');
    const filterIndex = $item.data('filter-index');
    const $drawerBody = $('#filters-drawer-body');
    const activeFilters = $drawerBody.data('activeFilters');

    if (activeFilters && activeFilters[filterIndex]) {
      const filter = activeFilters[filterIndex];
      console.log('Removing filter:', filter.facetName, '=', filter.facetValue);

      if (filter.type === 'checkbox') {
        filter.element.prop('checked', false);
      } else if (filter.type === 'slider') {
        const sliderId = filter.element.data('slider-id');
        const $slider = $(`#slider-range_${sliderId}`, '#filters-drawer');
        const min = filter.element.data('slider-min');
        const max = filter.element.data('slider-max');
        $slider.slider('values', [min, max]);
        const $label = $(`#facet_label_${sliderId}`, '#filters-drawer');
        if ($label.length) {
          $label.text(min + ' - ' + max);
        }
      }

      updateCurrentUrl();
    }
  });

  $(document).on('click', '.js-search-filters-clear-all', function(e) {
    e.preventDefault();
    console.log('Clearing all filters');

    const $drawerBody = $('#filters-drawer-body');
    if ($drawerBody.length) {
      $drawerBody.find('input[type="checkbox"]:checked').prop('checked', false);

      $drawerBody.find('.faceted-slider').each(function() {
        const $sliderEl = $(this);
        const sliderId = $sliderEl.data('slider-id');
        const $slider = $(`#slider-range_${sliderId}`, '#filters-drawer');
        const min = $sliderEl.data('slider-min');
        const max = $sliderEl.data('slider-max');

        if ($slider.hasClass('ui-slider')) {
          $slider.slider('values', [min, max]);
          const $label = $(`#facet_label_${sliderId}`, '#filters-drawer');
          if ($label.length) {
            $label.text(min + ' - ' + max);
          }
        }
      });

      $drawerBody.find('#drawer-active-filters').remove();
    }

    const currentUrl = window.location.href;
    const urlWithoutParams = currentUrl.split('?')[0];
    window.location.href = urlWithoutParams;
  });
});
